import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Spin, Select, Input, Tabs, Space, InputNumber } from 'antd';
import { CheckCircleOutlined, HomeOutlined, CloseCircleOutlined, UploadOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, SearchOutlined ,DownloadOutlined} from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import Message from '../../component/message/message';
import SelectStudent from './selectStudent';
import SelectCohortModule from './selectCohortModule';
import moment from 'moment';//日期格式化导包
import BatchUpdateAssignedAsModel from './batchUpdateAssignedAsModel'
import CohortProgSearchModal from './cohortProgSearchModal'
import BatchAddModel from './batchAddModel'
import './studentModule.css';
const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

const StudentModule = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [flag, setFlag] = useState("");
    const [paramSegmentList, setParamSegmentList] = useState([]);
    const [paramModel, setParamModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [downloadModel, setDownloadModel] = useState("");
    const [selected, setSelected] = useState([]);
    const [updateInfoModel, setUpdateInfoModel] = useState({});

    const [isSearchModuleModal, setIsSearchModuleModal] = useState(false);
    const [isSelectStudent, setIsSelectStudent] = useState(false);
    const [studentModel, setStudentModel] = useState({});
    const [selectedSRowKeys, setSelectedRowKeys] = useState([]);
    const [cohortList, setCohortList] = useState([]);
    const [assignedList, setAssignedList] = useState([]);
    const [assignmentTable, setAssignmentTable] = useState([]);
    const [wpaTable, setWpaTable] = useState([]);
    const [existMc, setExistMc] = useState(false);
    const [isBatchUpdateAssignedAs, setIsBatchUpdateAssignedAs] = useState(false);
    const [isSearchCohortProgModal, setIsSearchCohortProgModal] = useState(false);
    const [cohortProgModel, setCohortProgModel] = useState({});
    const [isBatchAddModel, setIsBatchAddModel] = useState(false);
    
    const tableColumns = {
        segmentName: "short_desc",
        code: "code",
        dispSeq: "disp_seq"
    }


    useEffect(() => {
        searchCohortList()
        search(pageSize, 1, "N");
    }, []);

    const searchCohortList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("cohortModule/searchCohortList").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setCohortList(list)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }


    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList;
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("studentModuleAdmin/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        setSelectedRowKeys([])
        setSelected([])
        setCohortProgModel({});
    }

    // Tab页切换
    const handleSelect = (key) => {
        messageShowHandler();
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({ status: "ACTIVE" });
        setFlag("add");
        setTabIndex("2");
        setAssignmentTable([])
        setWpaTable([])
        setAssignedList([])
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            cohortId: model.cohortId ?? '',
            semester: model.semester ?? '',
            studentAcctId: model.studentAcctId ?? '',
            firstName: model.firstName ?? '',
            moduleCode: model.moduleCode ?? '',
            moduleName: model.moduleName ?? '',
            progCode: model.progCode ?? '',
            progTitle: model.progTitle ?? '',
            academicSupervisorUserId: model.academicSupervisorUserId ?? '',
            status: model.status ?? '',
            group: model.group ?? '',
            assignMarks: model.assignMarks ?? 'N/A',
            wpaMarks: model.wpaMarks ?? 'N/A',
            totalModuleMark: model.totalModuleMark ?? 'N/A',
        });
    }


    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = paramModel;
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("studentModuleAdmin/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }


    const onSave = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let url = "";
        if (flag === "add") {
            url = "studentModuleAdmin/insert";
        } else {
            url = "studentModuleAdmin/update"
            values.studentModuleId = paramModel.studentModuleId;
            values.lastUpdatedDate = paramModel.lastUpdatedDate;
        }
        values.studentId = studentModel.studentId;
        values.cohortModuleId = studentModel.cohortModuleId;
        values.menuFuncId = Config.funcInfo.funcId;
        if(values?.assignMarks == 'N/A') {
            values.assignMarks = null;
        }
        if(values?.wpaMarks == 'N/A') {
            values.wpaMarks = null;
        }
        if(values?.totalModuleMark == 'N/A') {
            values.totalModuleMark = null;
        }
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "N");
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const update = (model, e) => {
        e.stopPropagation();
        initForm(model);
        setFlag("edit");
        searchById(model.studentModuleId)
        setTabIndex("2");
    }

    const searchById = (studentModuleId, isDelete) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("studentModuleAdmin/searchById", { studentModuleId: studentModuleId }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setParamModel(model)
                academicSearch(model.cohortProgId)
                setStudentModel(model)
                setFlag("edit");
                initForm(model)
                setAssignmentTable(model.studentModuleAssignModelList)
                setWpaTable(model.wpaApplModelList)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setParamModel(model)
        setIsDeleteFrame(true);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const uploadClose = (flag, model) => {
        if (flag) {
            setStudentModel({
                ...studentModel, ...{
                    firstName: model.firstName,
                    studentAcctId: model.studentAcctId,
                    studentId: model.studentId
                }
            })
            form.setFieldsValue({
                firstName: model.firstName ?? "",
                studentAcctId: model.studentAcctId ?? '',
            });
        }
        setIsSelectStudent(false);
    }

    const batchAddMClose = (flag, model) => {
        if (flag) {
            search(pageSize, 1, "N");
            errFrameShow("success", "Batch Upload successfully.");
        }
        setIsBatchAddModel(false);
    }
    
    const batchUpdateAssignedAsClose = (flag) => {
        if (flag) {
            search(pageSize, 1, "N");
            errFrameShow("success", "Update successfully.");
        }
        setIsBatchUpdateAssignedAs(false);
    }


    const selectCohortModuleClose = (flag, model) => {
        if (flag) {
            if (tabIndex === "1") {
                setSearchModel(model1 => {
                    return { ...model1, ...{ moduleCode: model.moduleCode } };
                });
            } else {
                setStudentModel({
                    ...studentModel, ...{
                        moduleCode: model.moduleCode,
                        moduleName: model.moduleName,
                        cohortModuleId: model.cohortModuleId,
                        progCode: model.progCode ?? "",
                        progTitle: model.progTitle ?? '',
                        cohortId: model.progTitle ?? '',
                    }

                })
                form.setFieldsValue({
                    moduleCode: model.moduleCode ?? "",
                    moduleName: model.moduleName ?? '',
                    progCode: model.progCode ?? "",
                    progTitle: model.progTitle ?? '',
                    cohortId: model.cohortId ?? '',
                    academicSupervisorUserId: ""
                });
                academicSearch(model.cohortProgId)
            }
        }

        setIsSearchModuleModal(false);
    }

    const academicSearch = (cohortProgId) => {
        Base.callBackApi("studentModuleAdmin/academicSearch", { cohortProgId: cohortProgId }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object.list ?? []
                setAssignedList(list)
                setExistMc(data.object.existMc === "Y")
                if (flag === "add" && data.object.existMc === "Y" && list && list.length > 0) {
                    form.setFieldsValue({
                        academicSupervisorUserId: list[0].userId
                    });
                }
            } else {
                errFrameShow("error", data.msg);
            }
        });
    }

    const batchUpdateAssignedAs = () => {
        messageShowHandler();
        if (!selected || selected.length === 0) {
            errFrameShow("error", "Please select at least one record.");
            return
        }
        if (!selected.every(element => element.cohortProgId === selected[0].cohortProgId)) {
            errFrameShow("error", "Please select data with the same Cohort Programme.");
            return
        }
        setUpdateInfoModel({
            cohortProgId: selected[0].cohortProgId,
            studentModuleIds: selectedSRowKeys
        })
        setIsBatchUpdateAssignedAs(true)
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setSelected(selectedRows);
    }

    const downloadTemplate = () => {
        setIsLoad(true);
        setSpinInfo("Loading...")
        fetch(Config.apiDownloadServer + "studentModuleTemplate/exportTemplate", {
            method: 'POST',
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    // errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                var filename = "StudentModuleTemplate.xlsx";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    const closeSearchCohortProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, cohortProgId: cohortProg.cohortProgId} };
            });
            setCohortProgModel(cohortProg);
        }
        setIsSearchCohortProgModal(false);
    }

    const columns = [
        {
            title: "Cohort",
            dataIndex: 'cohortYear',
            className: 'tableWidth4',
        },
        {
            title: "Semester",
            dataIndex: 'semester',
            className: 'tableWidth5',
        },
        {
            title: "Student ID",
            dataIndex: 'studentAcctId',
            className: 'tableWidth6',
        },
        {
            title: "Student Name",
            dataIndex: 'firstName',
            className: 'tableWidth8',
            render: (text, record) => (record?.firstName ?? '') + ' ' + (record?.lastName ?? '')
        },
        {
            title: "Module Code",
            dataIndex: 'moduleCode',
            className: 'tableWidth7',
        },
        {
            title: "Module Name",
            dataIndex: 'moduleName',
            className: 'tableWidth9',
        },
        {
            title: "Programme Code",
            dataIndex: 'progCode',
            className: 'tableWidth7',
        },
        {
            title: "Programme Name",
            dataIndex: 'progTitle',
            className: 'tableWidth9',
        },
        {
            title: "Assigned-AS",
            dataIndex: 'staffName',
            className: 'tableWidth8',
        },
        {
            title: "Assign Mark",
            dataIndex: 'assignMarks',
            className: 'tableWidth6',
            render: (text) => Base.numberReplaceSymbol(text, "N/A")
        },
        {
            title: "WPA Mark",
            dataIndex: 'wpaMarks',
            className: 'tableWidth6',
            render: (text) => Base.numberReplaceSymbol(text, "N/A")
        },
        {
            title: "WPA Weight Adjusted",
            dataIndex: 'wpaAdjustWeightCount',
            className: 'tableWidth9',
            render: text => text > 0 ? 'Y' : 'N'
        },
        {
            title: 'Total Module Mark',
            dataIndex: 'totalModuleMark',
            className: 'tableWidth8',
            render: (text) => Base.numberReplaceSymbol(text, "N/A")
        },
        {
            title: "Status",
            dataIndex: 'status',
            className: 'tableWidth5',
            render: (text) => ContextHandler.getMapValue('studentModuleStatusMap', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            fixed: 'right',
            width: 208,
            className: 'sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    const assignmentColumns = [
        {
            title: 'Assignment',
            dataIndex: 'assignSeq',
            className: 'tableWidth8',
        },
        {
            title: 'Assignment Name',
            dataIndex: 'assignName',
            className: 'tableWidth30',
        },
        {
            title: 'Weighting',
            dataIndex: 'assignWeight',
            className: 'tableWidth10',
        },
        {
            title: 'Assignment Deadline',
            dataIndex: 'assignDeadline',
            className: 'tableWidth12',
            render: (text) => <div>
                <div>{text ? moment(text).format(Config.dateFormat5) : ""}</div>
            </div>
        },
        {
            title: 'Use Turnitin',
            dataIndex: 'turnitinReqInd',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValue('indStatusMap', text)
        },
        {
            title: 'Turnitin Score',
            dataIndex: 'turnitinScore',
            className: 'tableWidth10',
            render: (text) => text === 0? '0%' : text? `${text}%` : ''
        },
        {
            title: 'Assign Mark',
            dataIndex: 'assignMarks',
            className: 'tableWidth10',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValue('assignmentStatusMap', text)
        },


    ];


    const wpaColumns = [
        {
            title: 'WPA ID',
            dataIndex: 'wpaApplId',
            className: 'tableWidth6',
        },
        {
            title: 'Company',
            dataIndex: 'companyName',
            className: 'tableWidth34',
        },
        {
            title: 'Industry Supervisor',
            dataIndex: 'industrySupervisorName',
            className: 'tableWidth30',
        },
        {
            title: 'WIL Hours',
            dataIndex: 'wilHours',
            className: 'tableWidth6',
            render: (text) => Base.parseToFixed(text, 1),
        },
        {
            title: 'Mark',
            dataIndex: 'mark',
            className: 'tableWidth5',
            render: (text) => Base.parseToFixed(text, 1),
        },
        {
            title: 'Submit Date ',
            dataIndex: 'applyDate',
            className: 'tableWidth7',
            render: (text) => <div>
                <div>{text ? moment(text).format(Config.dateFormat5) : ""}</div>
            </div>
        },
        {
            title: 'Status',
            dataIndex: 'wpaStatus',
            className: 'tableWidth12',
            render: (text) => ContextHandler.getMapValue('wpaFormStatusMap', text)
        },

    ];

    const rowSelection = {
        selectedRowKeys: selectedSRowKeys,
        onChange: onSelectChange,
    };

    return (
        <div id="container" className="template studentModule">
            <div className='breadcrumb'>
                <HomeOutlined /> / Setup / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Student Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.firstName || ''}
                                            placeholder="Student Name"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('firstName', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Student ID</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.studentAcctId || ''}
                                            placeholder="Student ID"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('studentAcctId', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Module</div>
                                    <div className="sysButtonSearchInput">
                                        <Input type="text" value={searchModel.moduleCode || ''} disabled
                                            placeholder="Module"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('moduleCode', e.target.value)} />
                                    </div>
                                    <Button className="sysBtn btnBlue" onClick={() => { setIsSearchModuleModal(true) }}>Select</Button>
                                    {searchModel.moduleName && <div style={{ marginLeft: '10px' }}>{searchModel.moduleName}</div>}
                                </div>
                            </div>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Programme </div>
                                    <div className="sysButtonSearchInput">
                                        <Input type="text" value={searchModel.progCode || ''} disabled
                                            placeholder="Programme "
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('progCode', e.target.value)} />
                                    </div>
                                    <Button className="sysBtn btnBlue" onClick={() => { setIsSearchCohortProgModal(true) }}>Select</Button>
                                    {searchModel.progName && <div style={{ marginLeft: '10px' }}>{searchModel.progName}</div>}
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Assigned-AS</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.staffName || ''}
                                            placeholder="Assigned-AS"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('staffName', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="buttonRelative">
                                <Button className='sysBtn btnBlue' type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                                <Button className='sysBtn btnBlue' type="primary" onClick={downloadTemplate} hidden={Config.funcInfo.canUpload === "N"} icon={<DownloadOutlined />}>{trans.downloadTemplate[Config.backLang]}</Button>
                                <Button className='sysBtn btnBlue' type="primary" hidden={Config.funcInfo.canUpload === "N"} icon={<UploadOutlined />} onClick={()=> setIsBatchAddModel(true)}>Batch Upload</Button>
                                <Button className='sysBtn btnBlue' onClick={batchUpdateAssignedAs} type="primary" hidden={Config.funcInfo.canUpload === "N"} icon={<EditOutlined />}>Batch Update Assigned-AS</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowSelection={rowSelection} //选择
                                    rowKey="studentModuleId"
                                    scroll={{ x: 2300 }}
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab="Enrolled Module Student Record" key="2" forceRender={true}>
                            <Form form={form} onFinish={onSave}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Student ID</div>
                                        <div className={flag === "add" ? "sysInput btnInput" : "sysInput"}>
                                            <Form.Item
                                                name="studentAcctId"
                                                rules={[
                                                    { required: true, message: "Student ID is required." },
                                                ]}
                                            >
                                                <Input type="text" placeholder='Student ID' disabled className='BUttonProgramme' />
                                            </Form.Item>
                                        </div>
                                        {
                                            flag === "add" &&
                                            <Button type="primary" className='sysBtn btnBlue' onClick={() => setIsSelectStudent(true)}>Select</Button>
                                        }

                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Student Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="firstName"
                                            >
                                                <Input type="text" placeholder='Student Name' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Module Code</div>
                                        <div className={flag === "add" ? "sysInput btnInput" : "sysInput"}>
                                            <Form.Item
                                                name="moduleCode"
                                                rules={[
                                                    { required: true, message: "Module Code is required." },
                                                ]}
                                            >
                                                <Input type="text" placeholder='Module Code' disabled className='BUttonProgramme' />
                                            </Form.Item>
                                        </div>
                                        {
                                            flag === "add" &&
                                            <Button type="primary" className='sysBtn btnBlue' onClick={() => setIsSearchModuleModal(true)}>Select</Button>
                                        }
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Module Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="moduleName"
                                            >
                                                <Input type="text" placeholder='Module Name' maxLength={60} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">Programme Code</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="progCode"
                                            >
                                                <Input type="text" placeholder='Programme Code' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Programme Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="progTitle"
                                            >
                                                <Input type="text" placeholder='Programme Name' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Cohort</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="cohortId"
                                                rules={[
                                                    { required: true, message: "Cohort is required." },
                                                ]}
                                            >
                                                <Select className="sysSelect" placeholder="Cohort" disabled>
                                                    <Option value=''></Option>
                                                    {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Semester</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="semester"
                                            >
                                                <InputNumber type="text" placeholder='Semester' maxLength={1} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Assigned-AS</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="academicSupervisorUserId"
                                                rules={[
                                                    { required: true, message: "Assigned-AS is required." },
                                                ]}
                                            >
                                                <Select className="sysSelect" placeholder="Assigned-AS" >
                                                    <Option value=''></Option>
                                                    {assignedList.map((item) => <Option key={item.userId} value={item.userId}>{item.staffName}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Sub Group</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="group"
                                            >
                                                <Select className="sysSelect" placeholder="Sub Group" >
                                                    <Option value=''></Option>
                                                    {context.num9Map.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                {
                                    flag === "edit" &&
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam">Assign Mark</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignMarks"
                                                >
                                                    <Input type="text" placeholder='Assign Mark' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam">WPA Mark</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaMarks"
                                                >
                                                    <Input type="text" placeholder='WPA Mark' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Status</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="status"
                                                rules={[
                                                    { required: true, message: "Status is required." },
                                                ]}
                                            >
                                                <Select className="sysSelect" placeholder="Status" disabled>
                                                    <Option value=''></Option>
                                                    {context.studentModuleStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {flag === "edit" &&
                                        <div className='sysCol'>
                                            <div className="sysParam">Total Module Mark</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="totalModuleMark"
                                                >
                                                    <Input type="text" placeholder='Total Module Mark' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                            <div className="">
                                <div className="userRoleTitleRow2">Assignment</div>
                            </div>
                            <div className="packing-table " id="tableOne">
                                <Table
                                    scroll={{ x: 1400 }}
                                    rowKey="studentModuleAssignId" //Key值
                                    columns={assignmentColumns} //列名
                                    dataSource={assignmentTable} //数据
                                    pagination={false}
                                />
                            </div>

                            <div className="">
                                <div className="userRoleTitleRow2">WPA</div>
                            </div>
                            <div className="packing-table " id="tableOne">
                                <Table
                                    scroll={{ x: 1400 }}
                                    rowKey="wpaApplId" //Key值
                                    columns={wpaColumns} //列名
                                    dataSource={wpaTable} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isSearchModuleModal && <SelectCohortModule onClose={selectCohortModuleClose} />}
            {isSelectStudent && <SelectStudent onClose={uploadClose} />}
            {isBatchUpdateAssignedAs && <BatchUpdateAssignedAsModel onClose={batchUpdateAssignedAsClose} updateInfoModel={updateInfoModel} />}
            {isSearchCohortProgModal && <CohortProgSearchModal onClose={closeSearchCohortProgModal} />}
            {isBatchAddModel && <BatchAddModel onClose={batchAddMClose} />}
            
        </div>
    )

}

export default StudentModule;